module.exports = __webpack_public_path__ + "static/media/play.6efc79c6.svg";